import React from 'react'
import injectSheet from 'react-jss'
import { Modal } from '../../'
import { Cancel } from '../../icons/actionIcons'

class IconButton extends React.Component {
  constructor() {
    super()

    this.state = {
      open: false,
    }

    this.openModal = this.openModal.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  onClick() {
    const {
      disabled,
      handleClick,
      modal,
    } = this.props
    if (!disabled) {
      if (modal) {
        return this.openModal()
      }
      return handleClick()
    }
    return false
  }

  onKeyDown() {
    const {
      disabled,
      handleKeyDown,
      modal,
    } = this.props

    if (!disabled && handleKeyDown) {
      if (modal) {
        this.openModal()
      }
      handleKeyDown()
    }
    return false
  }

  openModal() {
    this.setState({
      open: true,
    })
  }

  closeModal() {
    this.setState({
      open: false,
    })
  }

  render() {
    const {
      classes,
      disabled,
      external,
      handleClick,
      href,
      icon,
      index = 0,
      large,
      modalText,
      modalTitle,
      primary,
      tip,
    } = this.props

    const { open } = this.state

    return (
      <div className={`${classes.iconButtonContainer} ${disabled && 'disabled'} ${large && 'large'}`}>
        {(href && !disabled) ? (
          <a
            className={`${classes.iconButton} ${primary && 'primary'}`}
            href={href}
            target={external ? '_blank' : '_self'}
          >
            {!icon ? (
              <Cancel />
            ) : icon}
            {tip && (
              <div className={`${classes.tip}`}>{tip}</div>
            )}
          </a>
        ) : (
          <React.Fragment>
            <div
              className={`${classes.iconButton} ${primary && 'primary'}`}
              role="button"
              tabIndex={index}
              onClick={this.onClick}
              onKeyDown={this.onKeyDown}
            >
              {!icon ? (
                <Cancel />
              ) : icon}
              {tip && (
                <div className={`${classes.tip}`}>{tip}</div>
              )}
            </div>
            {open && (
              <Modal
                action={handleClick}
                actionName={tip}
                closeModal={this.closeModal}
                text={modalText}
                title={modalTitle}
              />
            )}
          </React.Fragment>
        )}
      </div>
    )
  }
}

const styles = theme => ({
  iconButtonContainer: {
    opacity: 1,
    cursor: 'pointer',
    width: '20px',
    height: '20px',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
      },
    ],
    '&.disabled': {
      cursor: 'auto',
      opacity: 0,
    },
    '&.large': {
      width: '30px',
      height: '30px',
      '& $iconButton': {
        borderWidth: '3px',
      },
    },
  },
  iconButton: {
    position: 'relative',
    display: 'block',
    height: '100%',
    backgroundColor: theme.colors.main_2,
    borderColor: theme.colors.secondary_3b,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '50%',
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
    '& svg': {
      padding: '20%',
      fill: theme.colors.secondary_3b,
    },
    '& $tip': {
      color: theme.colors.secondary_3b,
    },
    '&:hover': {
      backgroundColor: theme.colors.secondary_3b,
      '& svg': {
        fill: theme.colors.main_2,
        transition: [
          {
            property: 'fill',
            duration: theme.speed.fast,
          },
        ],
      },
      '& $tip': {
        zIndex: 1,
        opacity: 1,
        transition: [
          {
            property: 'opacity',
            duration: theme.speed.medium,
            delay: theme.speed.fast,
          },
        ],
      },
    },
    '&.primary': {
      borderColor: theme.colors.main_1,
      backgroundColor: theme.colors.main_1,
      '& svg': {
        fill: theme.colors.main_2,
      },
      '& $tip': {
        color: theme.colors.main_1,
      },
      '&:hover': {
        backgroundColor: theme.colors.main_2,
        '& svg': {
          fill: theme.colors.main_1,
        },
      },
    },
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  tip: {
    position: 'absolute',
    padding: `2px ${theme.sizes.gutter / 2}px`,
    top: '-5px',
    left: '50%',
    transform: 'translate(-50%, -100%)',
    width: 'auto',
    whiteSpace: 'nowrap',
    fontSize: '0.5em',
    height: 'calc(0.5rem + 4px)',
    borderRadius: 'calc(0.25rem + 2px)',
    backgroundColor: theme.colors.secondary_3a,
    zIndex: -1,
    opacity: 0,
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        delay: 0,
      },
    ],
  },
})

export default injectSheet(styles)(IconButton)



// WEBPACK FOOTER //
// ./src/modules/core/components/iconButton.jsx